import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appDragAndDrop]'
})
export class DragAndDropDirective {

  @Output() filesDropped: EventEmitter<any> = new EventEmitter();

  @HostBinding('class.file-over') fileOver: boolean;

  constructor() { }

  @HostListener('dragover', ['$event'])
  onDragOver(event: Event){
    event.preventDefault();
    event.stopPropagation();
    this.fileOver = true;
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: Event){
    event.preventDefault();
    event.stopPropagation();
    this.fileOver = false;
  }

  @HostListener('mouseleave', ['$event'])
  onMouseLeave(event: Event){
    event.preventDefault();
    event.stopPropagation();
    this.fileOver = false;
  }

  @HostListener('drop', ['$event'])
  onDrop(event: Event){
    event.preventDefault();
    event.stopPropagation();
    this.fileOver = false;
    this.filesDropped.next((event as any).dataTransfer.files);
  }
}
